export type ChatExportTranslationStage = 'specialty' | 'content' | 'visible'

/** Export diagnostics never retain the source text or a provider error/cause. */
export class ChatExportTranslationError extends Error {
  readonly code = 'presentation_translation_unavailable'
  constructor(
    readonly stage: ChatExportTranslationStage,
    readonly segmentIndex?: number,
  ) {
    super('Presentation translation unavailable')
    this.name = 'ChatExportTranslationError'
  }
}

/** Only allowlisted codes/stages may cross the console boundary. */
export function chatExportFailureDetails(error: unknown) {
  if (error instanceof ChatExportTranslationError)
    return {
      code: error.code,
      stage: error.stage,
      ...(error.segmentIndex === undefined ? {} : { segmentIndex: error.segmentIndex }),
    }
  if (error instanceof Error && /^Obsolete (?:specialty )?presentation export$/.test(error.message))
    return { code: 'obsolete_export' }
  return { code: 'export_failed' }
}
